// Disabling sonar on next line as it was complaining about empty arrow fn
const Noop = () => {}; // NOSONAR

export default Noop;
